import { render, staticRenderFns } from "./Tbs.vue?vue&type=template&id=1656ba72&"
import script from "./Tbs.vue?vue&type=script&lang=js&"
export * from "./Tbs.vue?vue&type=script&lang=js&"
import style0 from "./Tbs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports